import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useRef, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {StepperComponent} from '../../../../../../../_metronic/assets/ts/components'
import {checkinAutoSchemas} from '../../../../../util/validationHoteleria'
import {CheckinAuto} from '../../../models/ckecking.model'
import {FormStep1Auto} from '../forms/FormStep1Auto'
import {FormStep2Auto} from '../forms/FormStep2Auto'
import {FormStep3Auto} from '../forms/FormStep3Auto'

const inits: CheckinAuto = {
  operationType: '',
  isGuest: false,
  AceptaTyC: false,
  errorCheck: false,
  fromStep1: false,
}

const CheckInAutoAuto: FC = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(checkinAutoSchemas[0])
  const [initValues] = useState<CheckinAuto>(inits)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)

  const methods = useForm<CheckinAuto>({
    defaultValues: initValues,
    resolver: yupResolver(currentSchema),
  })

  const {reset} = methods

  // const operationType = watch('operationType')

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentSchema(checkinAutoSchemas[currentStepIndex - 1])
    setCurrentStepIndex((prevIndex) => prevIndex - 1)
  }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }

    setCurrentSchema(checkinAutoSchemas[currentStepIndex])

    if (currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext()
      setCurrentStepIndex((prevIndex) => prevIndex + 1)
    }
  }

  const goToFirstStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(1)
    setCurrentStepIndex(0)
    setCurrentSchema(checkinAutoSchemas[0])
    reset()
  }

  const goToStep = (index: number) => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(index)
    setCurrentStepIndex(index - 1)
    setCurrentSchema(checkinAutoSchemas[index - 1])
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  return (
    <div className='card'>
      <div className='card-body'>
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column pt-15'
          id='kt_create_account_stepper'
        >
          <div className='stepper-nav mb-5'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Operación</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Ingresar Datos</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Resultados</h3>
            </div>
          </div>

          <FormProvider {...methods}>
            <form className='mx-auto mw-600px w-100 pt-15 pb-10' id='kt_create_account_form'>
              {/* Solo renderiza el paso actual */}
              {currentStepIndex === 0 && <FormStep1Auto nextStep={nextStep} prevStep={prevStep} />}
              {currentStepIndex === 1 && (
                <FormStep2Auto
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 2 && (
                <FormStep3Auto
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {/* {currentStepIndex === 3 && (
                <FormStep4
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )} */}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  )
}

export default CheckInAutoAuto
